__turbopack_context__.v({
  "active": "CompanyReviews-module__xcRtQa__active",
  "arrow": "CompanyReviews-module__xcRtQa__arrow",
  "carousel": "CompanyReviews-module__xcRtQa__carousel",
  "container": "CompanyReviews-module__xcRtQa__container",
  "content": "CompanyReviews-module__xcRtQa__content",
  "left": "CompanyReviews-module__xcRtQa__left",
  "reel": "CompanyReviews-module__xcRtQa__reel",
  "review": "CompanyReviews-module__xcRtQa__review",
  "reviewer": "CompanyReviews-module__xcRtQa__reviewer",
  "right": "CompanyReviews-module__xcRtQa__right",
  "title": "CompanyReviews-module__xcRtQa__title",
  "wrapper": "CompanyReviews-module__xcRtQa__wrapper",
});
